export const ABN_CAPTURE_REGEX = /(\d{2})(\d{3})(\d{3})(\d{3})/;

export const ABN_REGEX = /\d{11}/;

export enum BUSINESS_STRUCTURE {
  COMPANY = 'COMPANY',
  PARTNERSHIP = 'PARTNERSHIP',
  SOLE_TRADER = 'SOLE_TRADER',
  TRUST = 'TRUST',
}

export enum EMPLOYMENT_TYPE {
  PRIMARY = 'PRIMARY',
  SECONDARY = 'SECONDARY',
  PREVIOUS = 'PREVIOUS',
}

export enum EMPLOYMENT_EMPLOYMENT_TYPE {
  EMPLOYEE = 'EMPLOYEE',
  SELF_EMPLOYED = 'SELF_EMPLOYED',
  NOT_WORKING = 'NOT_WORKING',
}

export enum EMPLOYMENT_BASIS {
  FULL_TIME = 'FULL_TIME',
  PART_TIME = 'PART_TIME',
  CASUAL = 'CASUAL',
  CONTRACTOR = 'CONTRACTOR',
  MATERNITY_LEAVE = 'MATERNITY_LEAVE',
}

export enum EMPLOYMENT_SUB_TYPE {
  FULL_DOC = 'FULL_DOC',
  LOW_DOC = 'LOW_DOC',
}

export enum PRIVATE_OR_PUBLIC {
  PUBLIC = 'PUBLIC',
  PRIVATE = 'PRIVATE',
}
